module.exports = __webpack_public_path__ + "img/iconfont.640235a4.svg";